"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleForListFragmentDoc = exports.ArticleFullFragmentDoc = void 0;
const client_1 = require("@apollo/client");
const Attachment_generated_1 = require("./Attachment.generated");
const Region_generated_1 = require("./Region.generated");
exports.ArticleFullFragmentDoc = client_1.gql `
    fragment ArticleFull on Article {
  Id
  Type
  Important
  Header
  Body
  CreatedAt
  PromoAttachment {
    ...AttachmentObject
  }
  Region {
    ...RegionFull
  }
}
    ${Attachment_generated_1.AttachmentObjectFragmentDoc}
${Region_generated_1.RegionFullFragmentDoc}`;
exports.ArticleForListFragmentDoc = client_1.gql `
    fragment ArticleForList on Article {
  Id
  Type
  Important
  Header
  CreatedAt
  PromoAttachment {
    ...AttachmentObject
  }
  Region {
    ...RegionFull
  }
}
    ${Attachment_generated_1.AttachmentObjectFragmentDoc}
${Region_generated_1.RegionFullFragmentDoc}`;
//# sourceMappingURL=Article.generated.js.map